import { NgClass} from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AutoFocus } from 'primeng/autofocus';
import { Ripple } from 'primeng/ripple';
import { Notification } from '../../../core/interfaces/notification';
import { I18nService } from '../../../core/services/i18n.service';
import { SpsMenuItem } from '../../interfaces/sps-menu-item';

@Component({
  selector: 'sps-notifications-overlay-menu',
  imports: [
    Ripple,
    NgClass,
    AutoFocus,
    RouterLink
  ],
  templateUrl: './notifications-overlay-menu.component.html',
})
export class NotificationsOverlayMenuComponent implements OnInit, AfterViewInit {

  /**
   * Menu-Items for autofocus
   */
  @ViewChildren('menuLink') linkElements!: QueryList<ElementRef<HTMLAnchorElement>>;

  /**
   * Notifications for the active User
   */
  @Input() notifications: Notification[] = [];
  /** event emitter for menu item click */
  @Output() itemClicked = new EventEmitter<SpsMenuItem>();

  /** menu items for notification topbar menu */
  menuItems: SpsMenuItem[] = [];

  constructor(public i18n: I18nService) {
  }

  ngOnInit() {
    /**
     * init menu items for topbar notifications menu
     */
    this.menuItems = [
      {
        i18nLabelKey: 'NOTIFICATIONS',
        icon: 'pi pi-bell',
        autoFocus: true,
      },
    ]
  }

  ngAfterViewInit() {
    /**
     * Workaround
     * focus on first link
     * (force focus ring)
     */
    const first = this.linkElements.first;
    if (first) {
      first.nativeElement.focus({preventScroll: true});
      first.nativeElement.classList.add('force-focus-ring');
      const removeClass = () => {
        first.nativeElement.classList.remove('force-focus-ring');
        first.nativeElement.removeEventListener('blur', removeClass);
      };
      first.nativeElement.addEventListener('blur', removeClass);
    }
  }

  /**
   * callback function for click on menu item (no command menu item)
   */
  itemClick(event: Event, item: SpsMenuItem) {
    event.preventDefault();
    this.itemClicked.emit(item);
  }

  /**
   * callback function for click on command menu item
   */
  commandItemClick(event: Event, item: SpsMenuItem) {
    if (item.disabled) {
      event.preventDefault();
      return true;
    }
    /** execute command callback function */
    if (item.command) {
      item.command({originalEvent: event, item: item});
    }
  }

}
